/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

export const selectGlobal = state => state.global;

export const selectRouter = state => state.router;

export const makeSelectLayout = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.layout,
  );

export const makeSelectSidebar = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.sidebar,
  );

export const makeSelectTheme = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.theme,
  );

export const makeSelectCurrentTheme = () =>
  createSelector(
    makeSelectTheme(),
    theme => theme.currentTheme,
  );

export const makeSelectLoading = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.loading,
  );

export const makeSelectToken = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.auth.token,
  );

export const makeSelectUser = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.auth.user,
  );

export const makeSelectUserRole = () =>
  createSelector(
    makeSelectUser(),
    userState => (userState ? userState.role : undefined),
  );

export const makeSelectUserSettings = () =>
  createSelector(
    makeSelectUser(),
    userState => (userState ? userState.settings : undefined),
  );

export const makeSelectLocation = () =>
  createSelector(
    selectRouter,
    routerState => routerState.location,
  );

export const makeSelectNextPathname = () =>
  createSelector(
    selectRouter,
    routerState => routerState.location.state && routerState.location.state.nextPathname,
  );
